import { Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { ProtectedRoute, PublicRoute } from '@/components/routing';

// Lazy load payment pages
const Subscriptions = lazy(() => import('@/pages/Subscriptions'));
const SubscriptionSuccess = lazy(() => import('@/pages/SubscriptionSuccess'));
const PaymentSuccess = lazy(() => import('@/pages/PaymentSuccess'));
const InscriptionTunnel = lazy(() => import('@/components/inscription/InscriptionTunnel'));
const PackInscriptionTunnel = lazy(() => import('@/components/inscription/PackInscriptionTunnel'));
const InscriptionAnnulation = lazy(() => import('@/pages/InscriptionAnnulation'));
const InscriptionEntreprisePending = lazy(() => import('@/pages/InscriptionEntreprisePending'));
const InscriptionEmployeeMultiPending = lazy(() => import('@/pages/InscriptionEmployeeMultiPending'));
const LevelAssessment = lazy(() => import('@/pages/LevelAssessment'));
const FinancingRequestSuccess = lazy(() => import('@/pages/FinancingRequestSuccess'));
import TestPayment from '@/pages/TestPayment';

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    Chargement...
  </div>
);

export function PaymentRoutes() {
  return (
    <>
      <Route 
        path="/subscriptions" 
        element={
          <Suspense fallback={<PageLoader />}>
            <Subscriptions />
          </Suspense>
        } 
      />
      <Route 
        path="/subscription/success" 
        element={
          <Suspense fallback={<PageLoader />}>
            <SubscriptionSuccess />
          </Suspense>
        } 
      />
      <Route 
        path="/payment/success" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PaymentSuccess />
          </Suspense>
        } 
      />
      <Route 
        path="/paiement/success" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PaymentSuccess />
          </Suspense>
        } 
      />
      <Route 
        path="/financement/success" 
        element={
          <Suspense fallback={<PageLoader />}>
            <FinancingRequestSuccess />
          </Suspense>
        } 
      />
      {/* Routes inscription - STATIQUES EN PREMIER */}
      <Route 
        path="/inscription/pack" 
        element={
          <Suspense fallback={<PageLoader />}>
            <PackInscriptionTunnel />
          </Suspense>
        } 
      />
      <Route 
        path="/inscription/annulation" 
        element={
          <Suspense fallback={<PageLoader />}>
            <InscriptionAnnulation />
          </Suspense>
        } 
      />
      <Route 
        path="/inscription/employee-multi/pending/:paymentRequestId" 
        element={
          <Suspense fallback={<PageLoader />}>
            <InscriptionEmployeeMultiPending />
          </Suspense>
        } 
      />
      {/* Route inscription - DYNAMIQUE EN DERNIER */}
      <Route 
        path="/inscription/:courseId" 
        element={
          <Suspense fallback={<PageLoader />}>
            <InscriptionTunnel />
          </Suspense>
        } 
      />
      <Route 
        path="/assessment/:token" 
        element={
          <Suspense fallback={<PageLoader />}>
            <LevelAssessment />
          </Suspense>
        } 
      />
      <Route 
        path="/test-payment" 
        element={
          <ProtectedRoute requireAdmin={true}>
            <TestPayment />
          </ProtectedRoute>
        } 
      />
    </>
  );
}
